import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
import { FileUploadService } from 'src/app/Services/file-upload.service';
import indiaStates from '../../../../../../../assets/js/india.state.list.json';
import { CommonServices } from 'src/app/Services/common.service';


@Component({
    selector: 'app-single-view-employee',
    templateUrl: './singleEmployee.html',
    styleUrls: ['./single-view-employee.component.css']
})

export class SingleViewEmployeeComponent implements OnInit {
    matFormSize = '13px';
    orgID: string;
    employeeID: string;
    employeeData: any;
    profile: any;
    defaultEmpImage = "../../../../../../../assets/images/home/employee.png";
    editEmployeeForm: FormGroup;
    public stateSelect = indiaStates.IND;
    options: { name: string }[] = [];
    branchInformation: any[] = [];
    shiftInformation: any[] = [];
    shiftArr: any[] = [];
    locationData: any = {};
    profileImage: any;
    headerSubtitle = '';

    constructor(
        public api: ApiService,
        public router: Router,
        public route: ActivatedRoute,
        public swal: SweetAlert,
        public storage: StorageService,
        public file: FileUploadService,
        public comService: CommonServices,

    ) {
        this.orgID = this.storage.get('userInfo').orgID;
        this.route.paramMap.subscribe((params: any) => {
            this.employeeID = params.params.employeeID;
        });
    }

    ngOnInit() {
        this.addFormLoad();
        this.getStateOptions();
        this.getBranchList();
        this.getListShift();
        this.getEmployeeData();
    }

    addFormLoad() {
        this.editEmployeeForm = new FormGroup({
            name: new FormControl('', [Validators.required]),
            empRefID: new FormControl('', [Validators.required]),
            email: new FormControl('', [Validators.required, Validators.email]),
            dob: new FormControl(''),
            gender: new FormControl('', [Validators.required]),
            mobile: new FormControl('', [Validators.required, Validators.pattern('[0-9]\\d{9}')]),
            emergencyContact: new FormControl('', [Validators.required, Validators.pattern('[0-9]\\d{9}')]),
            bloodGroup: new FormControl(''),
            address: new FormControl(''),
            city: new FormControl(''),
            state: new FormControl(''),
            country: new FormControl('India'),
            pincode: new FormControl(''),
            transportType: new FormControl('', [Validators.required]),
            department: new FormControl('', [Validators.required]),
            workLocation: new FormControl('', [Validators.required]),
            area: new FormControl('', [Validators.required]),
            tripType: new FormControl(''),
            branch: new FormControl('', [Validators.required]),
            shift: new FormControl('', [Validators.required]),
            location: new FormControl(''),
            empProfile: new FormControl(''),
            seatType: new FormControl(''),
        });
    }

    getStateOptions() {
        this.stateSelect.forEach(element => {
            this.options.push({ name: element });
        });
    }

    getBranchList() {
        const obj = {
            orgID: this.storage.get('userInfo').orgID
        };
        this.api.transportManagerBranchList(obj).then((res: any) => {
            if (res.status == 'success' && res.data?.length > 0) {
                this.branchInformation = [];
                res.data.filter((e) => {
                    const option = { name: e.branchName, value: e.branchID };
                    this.branchInformation.push(option);
                });
            }
        }).catch((err) => {
            console.log(err);
        });
    }

    getListShift() {
        const obj = {
            orgID: this.orgID
        };
        this.api.ListShift(obj).then((res: any) => {
            if (res.status == 'success') {
                this.shiftInformation = res.data;
                if (this.employeeData?.branch) {
                    this.onChangeBrach(this.employeeData.branch);
                }
            }
        }).catch((err) => {
            console.log(err);
        });
    }

    onChangeBrach(val) {
        this.shiftArr = [];
        this.shiftInformation.forEach((element) => {
            if (element.branch == val) {
                this.shiftArr.push(element);
            }
        });
    }

    getEmployeeData() {
        const obj = {
            orgID: this.orgID,
            employeeID: this.employeeID
        };
        this.api.transportManagerEmployeeList(obj).then((res: any) => {
            if (res.status == 'success') {
                this.employeeData = res.data[0];
                this.setValueEditEmployeeForm(this.employeeData);
            }
        }).catch((err) => {
            console.log(err);
        });
    }

    setValueEditEmployeeForm(data) {
        if (data?.location?.lat == null && data?.location?.lng == null) {
            data.location = '';
        }

        this.editEmployeeForm.patchValue({
            name: data?.name || '',
            empRefID: data?.empRefID ? '' + data.empRefID : '',
            area: data?.area || '',
            email: data?.email || '',
            dob: data?.dob ? (data?.dob == 1 ? new Date(631132200000) : new Date(data?.dob)) : '',
            gender: data?.gender ? this.comService.convertTitleCase(data?.gender) : '',
            mobile: data?.mobile || '',
            emergencyContact: data?.emergencyContact || '',
            bloodGroup: data?.bloodGroup ? String(data.bloodGroup).toLowerCase() : '',
            address: data?.address || '',
            city: data?.city || '',
            state: data?.state || '',
            country: data?.country || 'India',
            pincode: data?.pincode || '',
            transportType: data?.transportType || '',
            department: data?.department || '',
            workLocation: data?.workLocation || '',
            branch: data?.branch || '',
            shift: data?.shift || '',
            location: data?.location ? data?.location?.name || '' : '',
            empProfile: data?.empProfile || '',
            seatType: data?.seatType || 'no',
            tripType: data?.tripType || '',
        });

        if (data?.empProfile) {
            this.profileImage = `${data.empProfile}?time=${Date.now()}`;
        }

        this.headerSubtitle = [
            data?.empRefID || '---',
            data?.gender ? this.comService.convertTitleCase(data.gender) : '---'
        ].join('  |  ');

        if (data?.seatType == 'yes') {
            this.editEmployeeForm.addControl('speciallyAbled', new FormControl(!!data?.speciallyAbled));
            if (data?.gender == 'Female') {
                this.editEmployeeForm.addControl('pregnancy', new FormControl(!!data?.pregnancy));
            }
        }

        this.locationData = { ...data?.location };
        this.onChangeBrach(data?.branch);
        this.editEmployeeForm.disable();
    }

    getBranchName(value: string) {
        const branch = this.branchInformation.find((item) => item.value == value);
        return branch ? this.comService.convertTitleCase(branch.name) : (value || '---');
    }

    getShiftName(value: string) {
        const shift = this.shiftInformation.find((item) => item.shiftID == value);
        return shift ? this.comService.convertTitleCase(shift.shiftName) : (value || '---');
    }

    getTransportTypeLabel(value: string) {
        if (value === 'company') return 'Company vehicle';
        if (value === 'others') return 'Others';
        return value || '---';
    }

    getDepartmentLabel(value: string) {
        if (value) return this.comService.convertTitleCase(value);
        return '---';
    }

    getTripTypeLabel(value: string) {
        if (value) return this.comService.convertTitleCase(value);
        return '---';
    }

    getSeatPreferenceLabel(value: string) {
        if (value === 'yes') return 'Yes';
        if (value === 'no') return 'No';
        return '---';
    }

    getDisplayValue(value: any) {
        return value !== null && value !== undefined && value !== '' ? value : '---';
    }

    getDobDisplay(value: any) {
        if (!value) return '---';
        if (value == 1) return '---';
        const date = value instanceof Date ? value : new Date(value);
        if (isNaN(date.getTime())) return '---';
        return date.toLocaleDateString('en-US');
    }

    getBloodGroupDisplay(value: string) {
        return value ? String(value).toUpperCase() : '---';
    }

    getProfileInitials(name: string) {
        if (!name) return 'NA';
        const parts = String(name).trim().split(/\s+/).filter(Boolean);
        if (!parts.length) return 'NA';
        if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
        return `${parts[0].charAt(0)}${parts[1].charAt(0)}`.toUpperCase();
    }

    async convertURLintoImg(url) {
        let imageFile = await this.file.urlHandleBase64(url);
        return imageFile;
    }
}
